/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactSwitch
 */
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWinjs = require('react-winjs');

var _reactWinjs2 = _interopRequireDefault(_reactWinjs);

var Switch = _react2['default'].createClass({
  displayName: 'Switch',

  propTypes: {
    value: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    onValueChange: _react.PropTypes.func,
    onTintColor: _react.PropTypes.string,
    thumbTintColor: _react.PropTypes.string,
    tintColor: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onTintColor: '#00e158',
      thumbTintColor: '#fff',
      tintColor: '#fff'
    };
  },

  getInitialState: function getInitialState() {
    return {
      value: this.props.value,
      disabled: this.props.disabled,
      previousValue: this.props.value
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
      disabled: nextProps.disabled,
      previousValue: nextProps.value
    });
  },

  getStyles: function getStyles() {
    return {
      span: {
        cursor: 'default' },
      // pointer will cause a grey background color on chrome
      checkedSpan: {
        //         borderColor: this.props.onTintColor,
        //         backgroundColor: this.props.onTintColor,
      },
      uncheckedSpan: {
        //        backgroundColor: this.props.tintColor,
      },
      disabledSpan: {
        opacity: 0.5,
        cursor: 'not-allowed',
        boxShadow: 'none'
      }
    };
  },

  toggleReference: function toggleReference(winjstoggle) {
    this.winjstoggle = winjstoggle;
  },

  handleChange: function handleChange(e) {
    if (this.state.disabled) {
      return null;
    }

    //    console.log("value = " + this.winjstoggle.winControl.checked);
    if (this.state.value !== this.winjstoggle.winControl.checked) {
      this.props.onValueChange && this.props.onValueChange.call(this, this.winjstoggle.winControl.checked);
      this.setState({
        value: this.winjstoggle.winControl.checked
      });
    }
  },

  render: function render() {
    var styles = this.getStyles();
    var spancss = this.state.value ? _extends({}, styles.span, styles.checkedSpan) : _extends({}, styles.span, styles.uncheckedSpan);
    spancss = this.state.disabled ? _extends({}, spancss, styles.disabledSpan) : spancss;

    return _react2['default'].createElement(_reactWinjs2['default'].ToggleSwitch, {
      ref: this.toggleReference,
      style: spancss,
      checked: this.state.value,
      onChange: this.handleChange,
      disabled: this.state.disabled,
      labelOn: '',
      labelOff: ''
    });
  }

});
module.exports = Switch;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/Switch/Switch.winjs.js
 **/